import { css } from '@emotion/react';

const getActionOverflowTriggerCss = css`
  svg {
    margin-left: var(--cds-spacing-100);
  }
`;

export default getActionOverflowTriggerCss;
